/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Gsoa_ShoppingList_GetAllShoppingLists_response } from '../models/Gsoa_ShoppingList_GetAllShoppingLists_response';
import type { Gsoa_ShoppingList_GetItems_response } from '../models/Gsoa_ShoppingList_GetItems_response';
import type { Gsoa_ShoppingList_GetItemsCollection } from '../models/Gsoa_ShoppingList_GetItemsCollection';
import type { Gsoa_ShoppingList_GetShoppingList_response } from '../models/Gsoa_ShoppingList_GetShoppingList_response';
import type { Gsoa_ShoppingList_NewItem } from '../models/Gsoa_ShoppingList_NewItem';
import type { Gsoa_ShoppingList_NewItem_response } from '../models/Gsoa_ShoppingList_NewItem_response';
import type { Gsoa_ShoppingList_NewShoppingList } from '../models/Gsoa_ShoppingList_NewShoppingList';
import type { Gsoa_ShoppingList_NewShoppingList_response } from '../models/Gsoa_ShoppingList_NewShoppingList_response';
import type { Gsoa_ShoppingList_SyncShoppingList } from '../models/Gsoa_ShoppingList_SyncShoppingList';
import type { Gsoa_ShoppingList_UpdateItem } from '../models/Gsoa_ShoppingList_UpdateItem';
import type { Gsoa_ShoppingList_UpdateItem_response } from '../models/Gsoa_ShoppingList_UpdateItem_response';
import type { Gsoa_ShoppingList_UpdateShoppingList } from '../models/Gsoa_ShoppingList_UpdateShoppingList';
import type { Gsoa_ShoppingList_UpdateShoppingList_response } from '../models/Gsoa_ShoppingList_UpdateShoppingList_response';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class GsoaShoppingListService {
    /**
     * Returns the list of shopping lists for the currently logged user.
     * @returns Gsoa_ShoppingList_GetAllShoppingLists_response OK
     * @throws ApiError
     */
    public static getShoppingLists({
        apiVersion = 1,
        page,
        pageSize = 30,
        filter,
    }: {
        apiVersion?: number,
        /**
         * Page order number (starts at 0)
         */
        page?: number,
        /**
         * The number of items per page
         */
        pageSize?: number,
        /**
         * <b>Filtering on response attributes</b><p><details><summary><b>Supported operators:</b></summary><p><i>eq</i> - checks if attribute is equals. Case sensitive when literal attribute.
         * <i>contains</i> - Value types: checks if attribute contains substring. Case Insensitive. Collection of value types: check if collection contains value. Case sensitive
         * </p></details><details><summary><b>Supported attributes - examples:</b></summary><p>Items.Name:eq Abc </br>Items.Name:contains ab </br>Items.IsActive:eq Abc </br></p></details>Combinations possible, concatenation with ";;" means logical AND. E.g.: Items.Name:eq Abc;;Items.Name:contains ab </p>
         */
        filter?: string,
    }): CancelablePromise<Gsoa_ShoppingList_GetAllShoppingLists_response> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v{apiVersion}/gsoa/shoppingLists',
            path: {
                'apiVersion': apiVersion,
            },
            query: {
                'page': page,
                'pageSize': pageSize,
                'filter': filter,
            },
            errors: {
                401: `An error occurred.`,
                500: `An error occurred.`,
            },
        });
    }
    /**
     * Create a new shopping list.
     * Attribute Name in NewShoppingListRequestDTO is mandatory and cannot be an empty string. \
     * If the current user does not have a shopping list with an attribute isActive = true then new shopping list will be set as active by default.
     * @returns Gsoa_ShoppingList_NewShoppingList_response OK
     * @throws ApiError
     */
    public static createNewShoppingList({
        requestBody,
        apiVersion = 1,
    }: {
        /**
         * Entity NewShoppingListRequestDTO
         */
        requestBody: Gsoa_ShoppingList_NewShoppingList,
        apiVersion?: number,
    }): CancelablePromise<Gsoa_ShoppingList_NewShoppingList_response> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v{apiVersion}/gsoa/shoppingLists',
            path: {
                'apiVersion': apiVersion,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error.`,
                401: `An error occurred.`,
                500: `An error occurred.`,
            },
        });
    }
    /**
     * Returns the last change date for current user's shopping lists.
     * The Last-Modified response HTTP header when StatusCode = 200
     * @returns void
     * @throws ApiError
     */
    public static getShoppingListsMetadata({
        apiVersion = 1,
    }: {
        apiVersion?: number,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'HEAD',
            url: '/api/v{apiVersion}/gsoa/shoppingLists',
            path: {
                'apiVersion': apiVersion,
            },
            errors: {
                401: `An error occurred.`,
                500: `An error occurred.`,
            },
        });
    }
    /**
     * @returns void
     * @throws ApiError
     */
    public static getApiVGsoaShoppingListsIsAlive({
        apiVersion = 1,
    }: {
        apiVersion?: number,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v{apiVersion}/gsoa/shoppingLists/isAlive',
            path: {
                'apiVersion': apiVersion,
            },
        });
    }
    /**
     * Returns the attributes of the specified shopping list.
     * @returns Gsoa_ShoppingList_GetShoppingList_response OK
     * @throws ApiError
     */
    public static getShoppingList({
        shoppingListId,
        apiVersion = 1,
    }: {
        /**
         * The shopping list identifier
         */
        shoppingListId: string,
        apiVersion?: number,
    }): CancelablePromise<Gsoa_ShoppingList_GetShoppingList_response> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v{apiVersion}/gsoa/shoppingLists/{shoppingListID}',
            path: {
                'apiVersion': apiVersion,
                'shoppingListID': shoppingListId,
            },
            errors: {
                401: `An error occurred.`,
                404: `An error occurred.`,
                410: `An error occurred.`,
                500: `An error occurred.`,
            },
        });
    }
    /**
     * Change attributes of a specified shopping list.
     * No mandatory atributes in UpdateShoppingListRequestDTO. \
     * If the Name attribute is not specified in the request the current entity Text value will not be affected. It cannot be set as null or empty.
     * If an isActive = true attribute is sent in the request and the selected shopping list is not active, this flag will be recalculated on all of the current user's shopping lists and will be set isActive = true only on current entity. \
     * Each user can have exactly one active shopping list.
     * @returns Gsoa_ShoppingList_UpdateShoppingList_response OK
     * @throws ApiError
     */
    public static updateShoppingList({
        shoppingListId,
        requestBody,
        apiVersion = 1,
    }: {
        /**
         * The shopping list identifier
         */
        shoppingListId: string,
        /**
         * Entity ShoppingListDTO.
         */
        requestBody: Gsoa_ShoppingList_UpdateShoppingList,
        apiVersion?: number,
    }): CancelablePromise<Gsoa_ShoppingList_UpdateShoppingList_response> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v{apiVersion}/gsoa/shoppingLists/{shoppingListID}',
            path: {
                'apiVersion': apiVersion,
                'shoppingListID': shoppingListId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error.`,
                401: `An error occurred.`,
                404: `An error occurred.`,
                410: `An error occurred.`,
                500: `An error occurred.`,
            },
        });
    }
    /**
     * Creates a new shopping list item.
     * Attribute Text in NewItemRequestDTO is mandatory. \
     * If there is already an entry with the matching Text or VANR attributes in selected shopping list, no new entry is created and current entity will be sent in response back.
     * @returns Gsoa_ShoppingList_NewItem_response OK
     * @throws ApiError
     */
    public static createNewItem({
        shoppingListId,
        requestBody,
        apiVersion = 1,
    }: {
        /**
         * The shopping list identifier
         */
        shoppingListId: string,
        /**
         * Entity NewShoppingListItemRequestDTO.
         */
        requestBody: Gsoa_ShoppingList_NewItem,
        apiVersion?: number,
    }): CancelablePromise<Gsoa_ShoppingList_NewItem_response> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v{apiVersion}/gsoa/shoppingLists/{shoppingListID}',
            path: {
                'apiVersion': apiVersion,
                'shoppingListID': shoppingListId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error.`,
                401: `An error occurred.`,
                404: `An error occurred.`,
                410: `An error occurred.`,
                500: `An error occurred.`,
            },
        });
    }
    /**
     * Delete shopping list.
     * Cannot delete shopping list with attribute isActive = true. \
     * If you need delete an active shopping list, you first need to choose another shopping list as active. \
     * This will reset the isActive attribute on the current purchase list to isActive = false and then you can delete it.
     * @returns void
     * @throws ApiError
     */
    public static deleteShoppingList({
        shoppingListId,
        apiVersion = 1,
    }: {
        /**
         * The shopping list identifier
         */
        shoppingListId: string,
        apiVersion?: number,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v{apiVersion}/gsoa/shoppingLists/{shoppingListID}',
            path: {
                'apiVersion': apiVersion,
                'shoppingListID': shoppingListId,
            },
            errors: {
                400: `Validation error.`,
                401: `An error occurred.`,
                404: `An error occurred.`,
                410: `An error occurred.`,
                500: `An error occurred.`,
            },
        });
    }
    /**
     * Returns the last change date for the shopping list specified by the identifier.
     * The Last-Modified response HTTP header when StatusCode = 200.
     * @returns void
     * @throws ApiError
     */
    public static getShoppingListMetadata({
        shoppingListId,
        apiVersion = 1,
    }: {
        /**
         * The shopping list identifier
         */
        shoppingListId: string,
        apiVersion?: number,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'HEAD',
            url: '/api/v{apiVersion}/gsoa/shoppingLists/{shoppingListID}',
            path: {
                'apiVersion': apiVersion,
                'shoppingListID': shoppingListId,
            },
            errors: {
                401: `An error occurred.`,
                404: `An error occurred.`,
                410: `An error occurred.`,
                500: `An error occurred.`,
            },
        });
    }
    /**
     * Returns all items of the shopping list specified by the identifier.
     * @returns Gsoa_ShoppingList_GetItems_response OK
     * @throws ApiError
     */
    public static getShoppingListItems({
        shoppingListId,
        apiVersion = 1,
        page,
        pageSize = 30,
        filter,
        houseNumber,
    }: {
        /**
         * The shopping list identifier
         */
        shoppingListId: string,
        apiVersion?: number,
        /**
         * Page order number (starts at 0)
         */
        page?: number,
        /**
         * The number of items per page
         */
        pageSize?: number,
        /**
         * <b>Filtering on response attributes</b><p><details><summary><b>Supported operators:</b></summary><p><i>eq</i> - checks if attribute is equals. Case sensitive when literal attribute.
         * <i>in</i> - checks if attribute equals one of posibilities. Case sensitive when literal attribute.
         * <i>contains</i> - Value types: checks if attribute contains substring. Case Insensitive. Collection of value types: check if collection contains value. Case sensitive
         * </p></details><details><summary><b>Supported attributes - examples:</b></summary><p>Items.Code:eq Abc </br>Items.Code:in Abc,def,ghi </br>Items.Text:eq Abc </br>Items.Text:contains ab </br>Items.AmountText:eq Abc </br>Items.Purchased:eq Abc </br></p></details>Combinations possible, concatenation with ";;" means logical AND. E.g.: Items.Code:eq Abc;;Items.Code:in Abc,def,ghi </p>
         */
        filter?: string,
        /**
         * House number used for product enrichment.
         */
        houseNumber?: number,
    }): CancelablePromise<Gsoa_ShoppingList_GetItems_response> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v{apiVersion}/gsoa/shoppingLists/{shoppingListID}/items',
            path: {
                'apiVersion': apiVersion,
                'shoppingListID': shoppingListId,
            },
            query: {
                'page': page,
                'pageSize': pageSize,
                'filter': filter,
                'houseNumber': houseNumber,
            },
            errors: {
                401: `An error occurred.`,
                404: `An error occurred.`,
                410: `An error occurred.`,
                500: `An error occurred.`,
            },
        });
    }
    /**
     * Save the request data to the shopping list
     * Collection itemsCreate - If there is already an entry with the matching Text or VANR attributes in selected shopping list, no new entry is created and current entity will be sent in response back.\
     * Collection itemsUpdate - If the attribute Code does not exist in the selected shopping list or item has been deleted a validation error is invoked.\
     * Collection itemsDelete - If the attribute Code does not exist in the selected shopping list a validation error is invoked. If the item was already deleted there is no error.
     * @returns Gsoa_ShoppingList_GetItems_response OK
     * @throws ApiError
     */
    public static updateShoppingListItems({
        shoppingListId,
        requestBody,
        apiVersion = 1,
    }: {
        /**
         * The shopping list identifier
         */
        shoppingListId: string,
        /**
         * List of SyncShoppingListRequestDTO
         */
        requestBody: Gsoa_ShoppingList_SyncShoppingList,
        apiVersion?: number,
    }): CancelablePromise<Gsoa_ShoppingList_GetItems_response> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v{apiVersion}/gsoa/shoppingLists/{shoppingListID}/items',
            path: {
                'apiVersion': apiVersion,
                'shoppingListID': shoppingListId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error.`,
                401: `An error occurred.`,
                500: `An error occurred.`,
            },
        });
    }
    /**
     * Delete all shopping list items.
     * @returns void
     * @throws ApiError
     */
    public static deleteShoppingListItems({
        shoppingListId,
        apiVersion = 1,
    }: {
        /**
         * The shopping list identifier
         */
        shoppingListId: string,
        apiVersion?: number,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v{apiVersion}/gsoa/shoppingLists/{shoppingListID}/items',
            path: {
                'apiVersion': apiVersion,
                'shoppingListID': shoppingListId,
            },
            errors: {
                401: `An error occurred.`,
                404: `An error occurred.`,
                410: `An error occurred.`,
                500: `An error occurred.`,
            },
        });
    }
    /**
     * Returns the last date of the change for items in the shopping list.
     * The Last-Modified response HTTP header when StatusCode = 200
     * @returns void
     * @throws ApiError
     */
    public static getShoppingListItemsMetadata({
        shoppingListId,
        apiVersion = 1,
    }: {
        /**
         * The shopping list identifier
         */
        shoppingListId: string,
        apiVersion?: number,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'HEAD',
            url: '/api/v{apiVersion}/gsoa/shoppingLists/{shoppingListID}/items',
            path: {
                'apiVersion': apiVersion,
                'shoppingListID': shoppingListId,
            },
            errors: {
                401: `An error occurred.`,
                404: `An error occurred.`,
                410: `An error occurred.`,
                500: `An error occurred.`,
            },
        });
    }
    /**
     * Returns the attributes of the specified shopping list item.
     * If an operation is performed over an entity that has since changed only the URI with actual entity resource in response Location header attribute will be send.
     * @returns Gsoa_ShoppingList_GetItemsCollection OK
     * @throws ApiError
     */
    public static getShoppingListItem({
        shoppingListId,
        itemId,
        apiVersion = 1,
    }: {
        /**
         * The shopping list identifier
         */
        shoppingListId: string,
        /**
         * The shopping list item identifier
         */
        itemId: string,
        apiVersion?: number,
    }): CancelablePromise<Gsoa_ShoppingList_GetItemsCollection> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v{apiVersion}/gsoa/shoppingLists/{shoppingListID}/items/{itemID}',
            path: {
                'apiVersion': apiVersion,
                'shoppingListID': shoppingListId,
                'itemID': itemId,
            },
            errors: {
                301: `Operation over an outdated entity.`,
                401: `An error occurred.`,
                404: `An error occurred.`,
                410: `An error occurred.`,
                500: `An error occurred.`,
            },
        });
    }
    /**
     * Update a shopping list item
     * Attribute Text in UpdateItemRequestDTO is mandatory. \
     * If an operation is performed over an entity that has since changed only the URI with actual entity resource in response Location header attribute will be send.
     * @returns Gsoa_ShoppingList_UpdateItem_response OK
     * @throws ApiError
     */
    public static updateShoppingListItem({
        shoppingListId,
        itemId,
        requestBody,
        apiVersion = 1,
    }: {
        /**
         * The shopping list identifier
         */
        shoppingListId: string,
        /**
         * The shopping list item identifier
         */
        itemId: string,
        /**
         * Entity ShoppingListItemsDTO
         */
        requestBody: Gsoa_ShoppingList_UpdateItem,
        apiVersion?: number,
    }): CancelablePromise<Gsoa_ShoppingList_UpdateItem_response> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v{apiVersion}/gsoa/shoppingLists/{shoppingListID}/items/{itemID}',
            path: {
                'apiVersion': apiVersion,
                'shoppingListID': shoppingListId,
                'itemID': itemId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                301: `Operation over an outdated entity.`,
                400: `Validation error.`,
                401: `An error occurred.`,
                404: `An error occurred.`,
                410: `An error occurred.`,
                500: `An error occurred.`,
            },
        });
    }
    /**
     * Delete the shopping list item.
     * If an operation is performed over an entity that has since changed only the URI with actual entity resource in response Location header attribute will be send.
     * @returns void
     * @throws ApiError
     */
    public static deleteShoppingListItem({
        shoppingListId,
        itemId,
        apiVersion = 1,
    }: {
        /**
         * The shopping list identifier
         */
        shoppingListId: string,
        /**
         * The shopping list item identifier
         */
        itemId: string,
        apiVersion?: number,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v{apiVersion}/gsoa/shoppingLists/{shoppingListID}/items/{itemID}',
            path: {
                'apiVersion': apiVersion,
                'shoppingListID': shoppingListId,
                'itemID': itemId,
            },
            errors: {
                301: `Operation over an outdated entity.`,
                401: `An error occurred.`,
                404: `An error occurred.`,
                410: `An error occurred.`,
                500: `An error occurred.`,
            },
        });
    }
}
